import { HttpClient } from '@angular/common/http';
import { IAppConfig } from '../interfaces/app-config';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AppConfig {
    static settings: any = {};

    load() {
        AppConfig.settings = environment.calSettings;
        AppConfig.settings.apiUrl = environment.apiUrl;
        AppConfig.settings.baseUrl = environment.baseUrl;
        return AppConfig.settings;
    }
}
